import type { FaireProductEntity } from "../../entity_types/product";

export const p_ez7an982sq: FaireProductEntity = {
  token: "p_ez7an982sq",
  type: "product",
  name: "Retro Minimalist Tote Bag For Women, Large Capacity Shoulder Bag",
  brandToken: "b_434zfwvrgm",
  brandName: "Ekartini",
  imageUrl:
    "https://cdn.faire.com/fastly/a34bc9289f6d0e2681159b8b0837a6fa4f2fe8e2ed6d8de560270aa8b9fc72a7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/70d5c5f6561a6bb8639afce11985645b49339b1f349e05e21d849a8bf7fddb83.jpeg",
    "https://cdn.faire.com/fastly/73956ecc7daf8f60bdbcde62013a99ba82b4f28601ca05d7c41edcbceab1d19c.jpeg",
    "https://cdn.faire.com/fastly/8d9d274a292db368b2c892ffa63d3fdc4d2b91c5699bca69c0cb3c507fb7c8e3.jpeg",
  ],
  priceDollars: 15.49,
  description:
    "The Ekartini Retro Minimalist Tote Bag For Women offers a large capacity, perfect for your daily essentials. This shoulder bag stands out with its unique design, blending retro and minimalist aesthetics. It's an excellent addition to any women's wardrobe, proving to be as versatile as it is stylish. This bag is designed to be your perfect companion.",
  tags: [],
  msrpDollars: 30.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:27.353Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
